import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userPermissions: { login: false }
  },
  mutations: {
    SET_USER_PERMISSIONS: (state, userPermissions) => {
      state.userPermissions = userPermissions;
      state.userPermissions["login"] = true;
    }
  }
});
